import { fmtDate } from "@/lib/api";

const LABELS = {
  sent: ["envoyé", "bg-emerald-100 text-emerald-800"],
  sending: ["envoi en cours", "bg-slate-100 text-slate-700"],
  no_consent: ["non envoyé (pas de consentement)", "bg-slate-100 text-slate-600"],
  disabled: ["non configuré", "bg-amber-100 text-amber-800"],
  error: ["erreur", "bg-red-100 text-red-800"],
};

const details = (c) => {
  if (c.status === "sent") return `Envoyé le ${fmtDate(c.sent_at)} · event_id ${c.event_id || "—"} · reçus : ${c.events_received ?? "?"} · fbtrace_id ${c.fbtrace_id || "—"}${c.test_event_code ? " · mode test" : ""}`;
  if (c.status === "error") return `${c.error || "Erreur"} (${c.attempts || 0} tentative(s))`;
  if (c.status === "disabled") return "Jeton META_CAPI_ACCESS_TOKEN non renseigné";
  if (c.status === "no_consent") return "Le visiteur n'avait pas accepté la mesure publicitaire Meta";
  return "";
};

export const CapiBadge = ({ order, testId = "order-detail-capi-badge", compact = false }) => {
  const c = order.capi || {};
  if (!compact && order.payment_status !== "paid" && !c.status) return null;
  const [label, cls] = LABELS[c.status] || ["en attente", "bg-slate-100 text-slate-600"];
  return (
    <div className={`flex items-center gap-2 ${compact ? "text-xs" : "text-sm"}`}>
      {!compact && <span className="font-semibold text-slate-800">Meta (serveur) :</span>}
      <span data-testid={testId} title={details(c)} className={`inline-flex px-2.5 py-1 rounded-full text-xs font-semibold ${cls}`}>{label}</span>
      {!compact && c.status === "error" && <span data-testid={`${testId}-error`} className="text-xs text-red-700 truncate max-w-[16rem]">{c.error}</span>}
    </div>
  );
};
